module.exports = __webpack_public_path__ + "assets/img/fomede_LIBER_lanche.f05d2937.png";